import React, { useCallback } from "react"
import styled from 'styled-components'
import { useSpring, animated as a } from 'react-spring'
import { theme } from '../../../GlobalStyle'

const StyledBurger = styled.button`
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`

const Burger = ({ isOpen, setOpen }) => {

  const { fill } = useSpring({
    fill: isOpen ? theme.color.bg : theme.color.black
  })
  
  const first = useSpring({
    transform: isOpen
      ? "translate(5px, 34px) rotate(-45deg)"
      : "translate(0px, 7px) rotate(0deg)"
  })
  const second = useSpring({
    opacity: isOpen ? 0 : 1,
    transform: isOpen
      ? "translate(0, 19px) scaleX(0)"
      : "translate(0px, 19px) scaleX(1)",
    transformOrigin: 'center'
  })
  const third = useSpring({
    transform: isOpen
      ? "translate(8px, 6px) rotate(45deg)"
      : "translate(0px, 32px) rotate(0deg)"
  })

  const handleClickButton = useCallback(() => setOpen(isOpen => !isOpen), [setOpen])

  return (
    <StyledBurger onClick={handleClickButton}>
      <a.svg
        width="40"
        height="32"
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
        fill={fill}
      >
        <a.rect width="40" height="4" rx="2" style={first} />
        <a.rect width="40" height="4" rx="2" style={second} />
        <a.rect width="40" height="4" rx="2" style={third} />
      </a.svg>
    </StyledBurger>
  )
}

export default Burger